import React from 'react';
import { useDispatch } from 'react-redux';
import { logout, selectAuth } from '../../../store/authSlice';
import { Dropdown } from 'react-bootstrap';
import { useAuth } from 'oidc-react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'hook/useReduxHooks';
import bssLogo from '../../../assets/images/bss-logo.svg';
import './style.css';

export default function HeaderBar() {
  const authState = useAppSelector(selectAuth);
  const auth = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <>
      <div style={{ height: '100%', width: '100%', display: 'flex', padding: '0px 32px 0px 32px' }}>
        <img alt="bssLogo" src={bssLogo} style={{ width: '40px', cursor: 'pointer' }} onClick={() => navigate(`/`)} />
        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
          <Dropdown>
            <Dropdown.Toggle className="custom-dropdown-toggle">Benvenuto {authState.displayName}</Dropdown.Toggle>
            <Dropdown.Menu className="custom-dropdown-menu">
              <Dropdown.Item
                className="custom-dropdown-item"
                onClick={async () => {
                  const idToken = auth.userData?.id_token;
                  await auth.signOut();
                  await auth.signOutRedirect({
                    id_token_hint: idToken,
                  });
                  dispatch(logout());
                }}
              >
                Log Out
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </>
  );
}
